import React from 'react';

interface StatusCircleProps {
  status: string;
}

const statusColorClass = (status: string) =>
  (
    {
      COMPLETED: 'bg-success',
      IN_PROGRESS: 'bg-warning',
      REJECTED: 'bg-danger',
    } as Record<string, string>
  )[status] ?? 'bg-secondary';

export const StatusCircle: React.FC<StatusCircleProps> = ({ status }) => (
  <span
    data-testid="status-circle"
    className={`d-inline-block rounded-circle ${statusColorClass(status)}`}
    style={{ width: '0.75rem', height: '0.75rem' }}
  />
);

